import { useEffect } from 'react';

/**
 * Carga las fuentes del rediseño mientras la app (/app/*) está montada:
 * Hanken Grotesk (texto), Source Serif 4 (títulos), IBM Plex Mono (etiquetas y
 * datos) y Material Symbols Rounded (iconos).
 *
 * - Material Symbols va con display=block: nunca muestra el nombre del icono en
 *   crudo mientras carga (con swap se alcanzaba a ver "receipt_long").
 * - Los <link> se marcan con data-a2-font para no duplicarlos si la landing ya
 *   los inyectó (al navegar landing → app) y para retirarlos al desmontar.
 */
const TEXT_HREF =
  'https://fonts.googleapis.com/css2?' +
  [
    'family=Hanken+Grotesk:wght@400;500;600;700;800',
    'family=IBM+Plex+Mono:wght@400;500;600;700',
    'family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,500;0,8..60,600;0,8..60,700;1,8..60,400;1,8..60,500',
  ].join('&') +
  '&display=swap';

const ICON_HREF =
  'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0,0&display=block';

const AppFonts = () => {
  useEffect(() => {
    const mine = [];
    const add = (attrs, crossOrigin) => {
      // Si otro montaje (o la landing) ya insertó exactamente este href, no se duplica.
      if (attrs.href && document.head.querySelector(`link[href="${attrs.href}"]`)) return;
      const link = document.createElement('link');
      Object.assign(link, attrs);
      if (crossOrigin) link.crossOrigin = 'anonymous';
      link.setAttribute('data-a2-font', '');
      document.head.appendChild(link);
      mine.push(link);
    };

    add({ rel: 'preconnect', href: 'https://fonts.googleapis.com' });
    add({ rel: 'preconnect', href: 'https://fonts.gstatic.com' }, true);
    add({ rel: 'stylesheet', href: TEXT_HREF });
    add({ rel: 'stylesheet', href: ICON_HREF });

    return () => mine.forEach((l) => l.parentNode && l.parentNode.removeChild(l));
  }, []);

  return null;
};

export default AppFonts;
